import axios from 'axios'

export default {

  // Signed file URLs expire, so fetch one when the user clicks download.
  freshUrl(exportId) {
    return axios({
      url: 'exports/' + exportId + '/url'
    })
  }
}
